<template>
  <div>
    <div class="pd-20">
      <a-table :columns="columns" :row-key="getKey" :data-source="list" :pagination="pagination" @change="handleTableChange">
        <div slot="effectTime" slot-scope="row">
          {{ row.effectBeginTime }} ~ {{ row.effectEndTime }}
        </div>

      </a-table>
    </div>
  </div>
</template>
<script>
// import SearchPannel from './searchPannel'
const columns = [
  { title: '获得时间', dataIndex: 'createTime', key: 'createTime' },
  { title: '优惠券编码', key: 'couponNumber', dataIndex: 'couponNumber' },
  { title: '名称', dataIndex: 'couponName', key: 'couponName' },
  { title: '金额（元）', dataIndex: 'amount', key: 'amount' },
  { title: '有效期', key: 'effectTime', scopedSlots: { customRender: 'effectTime' }},
  { title: '状态', dataIndex: 'statusName', key: 'statusName' },
  { title: '使用说明', dataIndex: 'couponDec', key: 'couponDec' }
]

export default {
  components: {
  },
  data() {
    return {
      settlementType: {
        1: '运费统计',
        2: '充值统计'
      },
      columns,
      params: {
      },
      list: [],
      pagination: {
        'current': 1,
        'pageSize': 10,
        total: 0
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async exp(button) {
      try {
        button.loading = true
        this.params.pageIndex = this.pagination.current
        this.params.pageSize = this.pagination.pageSize
        this.$down(this.$api.accountExportTransactionStatistics, this.params)
        button.loading = false
      } catch (error) {
        button.loading = false
      }
    },
    getKey(key) {
      return parseInt(Math.random() * 1000)
    },
    async handleTableChange(pagination) {
      this.pagination = { ...pagination }
      this.getList()
    },
    async getList(params) {
      if (params) {
        Object.assign(this.params, params)
      }
      this.params.pageIndex = this.pagination.current
      this.params.pageSize = this.pagination.pageSize
      const res = await this.$http(this.$api.couponGetCouponList, this.params)
      if (res) {
        this.list = res.list || []
        this.pagination.current = res.pageIndex
        this.pagination.pageSize = res.pageSize
        this.pagination.total = res.totalSize
      }
    }
  }
}
</script>
